import type { LearnerSurvey } from '~/gql/surveys/surveys'
import { useApolloClient } from '@apollo/client/react'
import { useState } from 'react'
import { GQL_MY_SURVEY } from '~/gql/surveys/surveys'
import { useCertificateDownload } from '~/hooks/use-certificate-download'

/**
 * Télécharger l'attestation, en proposant d'abord le questionnaire de fin de
 * parcours s'il n'a été ni rempli ni passé (#320).
 *
 * Jamais bloquant : si la question ne peut pas être posée (réseau, erreur),
 * l'attestation part directement. L'apprenant ne paie pas une panne de notre
 * questionnaire.
 */
export function useSurveyBeforeCertificate() {
  const client = useApolloClient()
  const { download, downloadingId } = useCertificateDownload()
  const [pending, setPending] = useState<{ sessionId: string, survey: LearnerSurvey } | null>(null)

  const request = async (sessionId: string) => {
    try {
      const { data } = await client.query({ query: GQL_MY_SURVEY, variables: { sessionId }, fetchPolicy: 'network-only' })
      if (data?.mySurvey.pending) {
        setPending({ sessionId, survey: data.mySurvey })
        return
      }
    } catch {
      // Le questionnaire n'est qu'une proposition : sa panne ne retient pas l'attestation.
    }
    await download(sessionId)
  }

  /** Questionnaire rempli ou passé : l'attestation part. */
  const finish = async () => {
    if (!pending) return
    const { sessionId } = pending
    setPending(null)
    await download(sessionId)
  }

  return { request, finish, pending, downloadingId }
}
